import { Button, Modal } from "@scuf/common";
import ISOTable from "./ISOTable";
import { getMountISO, setLoading } from "../../features/store/action";
import { useDispatch } from "react-redux";
import "../../features/components/dashboard/LeftContainer/css/plantDetail.scss";

const ISOModal = (props: any) => {
  const dispatch = useDispatch();

  const filterBySearch = (event: any) => {
    const query = event.target.value;
    props.setISOSearch(query);
    if (query.length > 1) {
      const filteredData = props.isoListReducer?.filter((item: any) => {
        return (
          item?.name?.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          item?.description?.toLowerCase().indexOf(query.toLowerCase()) !== -1
        );
      });
      props.setSelectedIso(null);
      props.setISOLiSt(filteredData);
    } else {
      props.setISOLiSt(props.isoListReducer);
    }
  };
  return (
    <Modal
      size={window.innerWidth > 1300 ? "large" : "small"}
      closeIcon={true}
      className="isoModalContainer"
      data-testid="iso-modal"
      onClose={() => {
        props.setShowIso(false);
        props.setISOSearch("");
        props.setISOLiSt(props.isoListReducer);
        props.setSelectedIso(null);
      }}
      open={props.showIso}
      closeOnDimmerClick={false}
      id="isoModal"
    >
      <Modal.Header>Select ISO to Insert Media</Modal.Header>
      <Modal.Content className="contentAction">
        <input
          id="search-iso"
          onChange={filterBySearch}
          className="search-iso"
          placeholder="Search iso by name and description"
          value={props.isoSearch}
          data-testid="iso-table-search-input"
          autoComplete="off"
        />
        {props.ISOList?.length > 0 ? (
          <ISOTable {...props} />
        ) : (
          <span className="no-result-text">No results for ISO</span>
        )}
      </Modal.Content>
      <Modal.Footer>
        <Button
          className="cancel-secondary"
          type="secondary"
          size="small"
          content="cancel"
          data-testid="iso-modal-cancel-media"
          onClick={() => {
            props.setShowIso(false);
            props.setISOSearch("");
            props.setISOLiSt(props.isoListReducer);
            props.setSelectedIso(null);
          }}
        />
        <Button
          className={
            props.ISOList?.length > 0 && props.selectedIso !== null
              ? "save-secondary"
              : "save-secondary-disable"
          }
          type="primary"
          size="small"
          content="Insert Media"
          data-testid="iso-modal-insert-media"
          disabled={
            props.selectedIso === null || props.isoListReducer?.length === 0
          }
          onClick={() => {
            dispatch(
              getMountISO({
                vmId: props.addSelectedID(props.selectedVM),
                authorization: localStorage.getItem("access_token"),
                siteId: props.orgData?.siteId,
                orgId: props.orgId,
                isoData: props.selectedIso,
              })
            );
            props.setShowIso(false);
            props.setISOSearch("");
            props.setISOLiSt(props.isoListReducer);
            dispatch(setLoading(true));
            props.setSelectedIso(null);
          }}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ISOModal;
